module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/vc-2614017538c99c0f2ea7b5823d128ae4.svg";